/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Header_View_CalculatorInputs */



/**
* | output |
* | --- |
* | "Cost calculator" |
*
* @param {Pricing_Header_View_CalculatorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_header_view_calculator = /** @type {((inputs?: Pricing_Header_View_CalculatorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Header_View_CalculatorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kostenrechner")
	return /** @type {LocalizedString} */ ("Cost calculator")
});